// const handleTransitionDirection = (to, from) => {
//   if (!from.meta.index || !to.meta.index) return true
//   to.meta.isReverse = from.meta.index > to.meta.index
//   return true
// }

const routes = [
  {
    path: '/',
    redirect: { name: 'App' },
    children: [
      {
        name: 'Legal',
        path: '/legal',
        meta: { authRequired: false, depth: 0, namespace: 'legal' },
        component: () => import('@/layouts/LayoutLegal.vue'),
        children: [
          {
            name: 'PrivacyPolicy',
            path: 'privacy-policy',
            meta: { depth: 1, namespace: 'privacy-policy' },
            component: () => import('@/pages/legal/PagePrivacyPolicy.vue')
          },
          {
            name: 'TermsConditions',
            path: 'terms-conditions',
            meta: { depth: 1, namespace: 'terms-conditions' },
            component: () => import('@/pages/legal/PageTermsConditions.vue')
          }
        ]
      },
      {
        name: 'Auth',
        path: '/auth',
        meta: { authRequired: false, depth: 0, namespace: 'auth' },
        component: () => import('@/layouts/LayoutAuth.vue'),
        children: [
          {
            name: 'Login',
            path: 'login',
            meta: { depth: 1, namespace: 'login' },
            components: {
              side: () => import('@/pages/auth/PageSideLogin.vue'),
              main: () => import('@/pages/auth/PageMainLogin.vue')
            }
          },
          {
            name: 'Register',
            path: 'register',
            meta: { depth: 1, namespace: 'register' },
            components: {
              side: () => import('@/pages/auth/PageSideRegister.vue'),
              main: () => import('@/pages/auth/PageMainRegister.vue')
            }
          },
          {
            name: 'ForgotPassword',
            path: 'forgot-password',
            meta: { depth: 1, namespace: 'forgot-password' },
            components: {
              side: () => import('@/pages/auth/PageSideForgotPassword.vue'),
              main: () => import('@/pages/auth/PageMainForgotPassword.vue')
            }
          },
          {
            path: 'reset-password',
            name: 'ResetPassword',
            meta: { depth: 1, namespace: 'reset-password' },
            components: {
              side: () => import('@/pages/auth/PageSideResetPassword.vue'),
              main: () => import('@/pages/auth/PageMainResetPassword.vue')
            }
          },
          {
            path: 'verify-email',
            name: 'VerifyEmail',
            meta: { authRequired: true, depth: 1, namespace: 'verify-email' },
            components: {
              side: () => import('@/pages/auth/PageSideVerifyEmail.vue'),
              main: () => import('@/pages/auth/PageMainVerifyEmail.vue')
            }
          },
          {
            path: 'mfa-challenge',
            name: 'MfaChallenge',
            meta: { depth: 1, namespace: 'mfa-challenge' },
            components: {
              side: () => import('@/pages/auth/PageSideMfaChallenge.vue'),
              main: () => import('@/pages/auth/PageMainMfaChallenge.vue')
            }
          },
          {
            path: 'oauth/callback',
            name: 'OAuthCallback',
            meta: { depth: 1, namespace: 'oauth-callback' },
            components: {
              side: () => import('@/pages/auth/PageSideOAuthCallback.vue'),
              main: () => import('@/pages/auth/PageMainOAuthCallback.vue')
            }
          },
          {
            path: 'callback/:provider',
            name: 'SocialCallback',
            meta: { depth: 1, namespace: 'oauth-callback' },
            components: {
              side: () => import('@/pages/auth/PageSideOAuthCallback.vue'),
              main: () => import('@/pages/auth/PageMainOAuthCallback.vue')
            }
          }
        ]
      },
      {
        name: 'App',
        path: '/',
        redirect: { name: 'Dashboard' },
        meta: { authRequired: true, verificationRequired: true, depth: 0, namespace: 'app' },
        component: () => import('@/layouts/LayoutApp.vue'),
        children: [
          {
            name: 'Inbox',
            path: 'inbox',
            meta: { depth: 1, namespace: 'inbox', icon: 'mono-inbox', header: () => import('@/components/inbox/HeaderInbox.vue') },
            component: () => import('@/pages/app/inbox/PageInbox.vue')
          },
          {
            name: 'Settings',
            path: 'settings',
            redirect: { name: 'SettingsAccountPreferences' },
            meta: { depth: 0, namespace: 'settings', icon: 'mono-gear' },
            children: [
              {
                name: 'SettingsAccount',
                path: 'account',
                redirect: { name: 'SettingsAccountPreferences' },
                meta: { depth: 1, namespace: 'settings-account', icon: 'mono-gear', parent: 'Settings' },
                component: () => import('@/pages/app/settings/PageSettingsAccount.vue'),
                children: [
                  {
                    name: 'SettingsAccountPreferences',
                    path: 'preferences',
                    meta: { depth: 2, namespace: 'settings-account-preferences', icon: 'mono-options', parent: 'SettingsAccount' },
                    component: () => import('@/pages/app/settings/panels/PanelSettingsPreferences.vue')
                  },
                  {
                    name: 'SettingsAccountProfile',
                    path: 'profile',
                    meta: { depth: 2, namespace: 'settings-account-profile', icon: 'mono-profile', parent: 'SettingsAccount' },
                    component: () => import('@/pages/app/settings/panels/PanelSettingsProfile.vue')
                  },
                  {
                    name: 'SettingsAccountNotifications',
                    path: 'notifications',
                    meta: { depth: 2, namespace: 'settings-account-notifications', icon: 'mono-notification', parent: 'SettingsAccount' },
                    component: () => import('@/pages/app/settings/panels/PanelSettingsNotifications.vue')
                  },
                  {
                    name: 'SettingsAccountSecurity',
                    path: 'security',
                    meta: { depth: 2, namespace: 'settings-account-security', icon: 'mono-shield', parent: 'SettingsAccount' },
                    component: () => import('@/pages/app/settings/panels/PanelSettingsSecurity.vue')
                  }
                ]
              }
            ]
          },
          {
            name: 'Dashboard',
            path: 'dashboard',
            meta: { depth: 1, namespace: 'dashboard', icon: 'mono-gauge' },
            component: () => import('@/pages/app/dashboard/PageDashboard.vue')
          },
          {
            name: 'Brands',
            path: 'brands',
            meta: {
              verificationRequired: false,
              depth: 1,
              namespace: 'brands',
              icon: 'mono-pill'
            },
            component: () => import('@/pages/app/brands/PageBrandSearch.vue')
          },
          {
            name: 'Brand',
            path: 'brands/:brandId',
            meta: {
              depth: 2,
              namespace: 'brand',
              icon: 'mono-brand',
              parent: 'Brands'
            },
            props: true,
            beforeEnter: to => {
              if (!to.query.tab) return { ...to, query: { ...to.query, tab: 'general' } }
            },
            component: () => import('@/pages/app/brands/PageBrand.vue'),
            // component: () => import('@/pages/app/brands/PageBrandSingle.bak.vue')
            // props: { main: true, side: true },
            // components: {
            //   main: () => import('@/pages/app/brands/PageBrandSingle.vue')
            //   // side: () => import('@/pages/app/brands/PageBrandSingleSide.vue')
            // }
            children: [
              {
                name: 'Presentation',
                path: ':presentationId',
                meta: { depth: 3, namespace: 'presentation', icon: 'mono-package', parent: 'Brand' },
                component: () => import('@/pages/app/brands/PagePresentationSingle.vue')
              },
              {
                name: 'Smpc',
                path: 'smpc',
                meta: { depth: 3, namespace: 'smpc', icon: 'mono-smpc', parent: 'Brand' },
                component: () => import('@/pages/app/brands/PageSmpcSingle.vue')
              }
            ]
          },
          {
            name: 'FavouriteGroups',
            path: 'favourites',
            meta: { depth: 1, namespace: 'favourites', icon: 'mono-star' },
            component: () => import('@/pages/app/favourites/PageFavGroupList.vue')
          },
          {
            name: 'FavouriteGroup',
            path: 'favourites/:groupId',
            meta: { depth: 2, namespace: 'favouriteGroup', icon: 'mono-star', parent: 'FavouriteGroups' },
            props: true,
            component: () => import('@/pages/app/favourites/PageFavGroupSingle.vue')
          },
          {
            name: 'Watchlists',
            path: 'watchlists',
            meta: { depth: 1, namespace: 'watchlist', icon: 'mono-watchlist' },
            component: () => import('@/pages/app/watchlists/PageWatchlistList.vue')
          },
          {
            name: 'Watchlist',
            path: 'watchlists/:watchlistId',
            meta: { depth: 2, namespace: 'watchlist', icon: 'mono-watchlist', parent: 'Watchlists' },
            props: true,
            redirect: { name: 'WatchlistChanges' },
            component: () => import('@/pages/app/watchlists/PageWatchlistSingle.vue'),
            children: [
              {
                name: 'WatchlistChanges',
                path: 'changes',
                meta: { depth: 3, namespace: 'watchlistChanges', icon: 'mono-history', parent: 'Watchlist' },
                component: () => import('@/pages/app/watchlists/PageWatchlistChanges.vue'),
                children: [
                  {
                    name: 'WatchlistChange',
                    path: ':changeId',
                    meta: { depth: 4, namespace: 'watchlistChange', icon: 'mono-history', parent: 'WatchlistChanges' },
                    component: () => import('@/pages/app/watchlists/PageWatchlistChangeSingle.vue')
                  }
                ]
              },
              {
                name: 'WatchlistResults',
                path: 'results',
                meta: { depth: 3, namespace: 'watchlistResults', icon: 'mono-search', parent: 'Watchlist' },
                component: () => import('@/pages/app/watchlists/PageWatchlistResults.vue')
              }
            ]
          },
          // Always leave this as last one
          {
            name: 'NotFound',
            path: ':pathMatch(.*)*',
            meta: { depth: 0, namespace: 'not-found', icon: 'mono-file-error' },
            component: () => import('@/pages/app/not-found/PageNotFound.vue')
          }
          // {
          //   name: 'Presentation',
          //   path: 'brands/:brandId/:presentationId',
          //   meta: { depth: 3, namespace: 'presentation', icon: 'mono-package', parent: 'Brand' },
          //   component: () => import('@/pages/app/presentation/PagePresentation.vue')
          // }

          // {
          //   name: 'Snapshots',
          //   path: 'sbapshots',
          //   meta: { depth: 1, namespace: 'snapshot', icon: 'duo-snapshots' },
          //   component: () => import('@/pages/app/snapshots/PageSnapshots.vue')
          // },
          // {
          //   name: 'Test',
          //   path: 'test',
          //   meta: { depth: 1, namespace: 'test', icon: 'duo-view-grid' },
          //   component: () => import('@/pages/app/test/PageTestGrid-2025-06-02.vue')
          // },
          // {
          //   name: 'Instantsearch',
          //   path: 'instantsearch',
          //   meta: { depth: 1, namespace: 'instantsearch', icon: 'duo-view-grid' },
          //   component: () => import('@/pages/app/instantsearch/PageInstantsearch.vue')
          // }
        ]
      }
    ]
  }
]

export default routes
